

import UiToolbar from 'kolibri-design-system/lib/keen/UiToolbar';

export default {
  name: 'KeenUiToolbar',
  extends: UiToolbar,
};

